import React, { useState, useEffect, useRef, useCallback } from 'react'
import {
  Affix,
  Button,
  Cascader,
  Checkbox,
  CheckboxGroup,
  Col,
  ControlLabel,
  Icon,
  Input,
  Message,
  MultiCascader,
  Panel,
  Radio,
  RadioGroup,
  Rate,
  Row,
  SelectPicker,
} from 'rsuite'

import { v4 as uuidv4 } from 'uuid'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import NumberFormat from 'react-number-format'
import classNames from 'classnames'
import notification from '../../utils/notification'
import ShowLimitLength from '../../components/utils/ShowLimitLength'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { saveAssessmentForm } from '../../redux/actions/assessment'
import { doneLoading, startLoading } from '../../utils/loading'
import { DEFAULT_ERR_MSG, SAVE_DRAFT_SUCCESS_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import EditButton from '../../components/buttons/editButton/EditButton'
import { getValueFromOptions } from '../../utils/dataUtil'
import { budgetFormat } from '../../utils/formatterUtil'
import { isEmpty } from 'lodash-es'
import {
  buildFilteredTree,
  getLabelsWithParents,
  loadLocation,
} from '../../components/location/Location'
import RenderLocationTree from '../assessment/RenderLocationTree'

export default function EvaluationFormWidget({
  schema,
  isPanel,
  progressId,
  isPreview,
  isDraftAssessment,
  assessmentFor,
  disabled,
  setIsDraftAssessment = () => {},
  ...props
}) {
  const [formSchema, setFormSchema] = useState(schema)

  const [questionBlocks, setQuestionBlocks] = useState(schema.assessmentCategoryForm || [])
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isEdit, setIsEdit] = useState(isPreview ? true : false)
  const [showRequiredMessage, setShowRequiredMessage] = useState(false)

  const [assessmentProjectId, setAssessmentProjectId] = useState()
  const [assessmentId, setAssessmentId] = useState()
  const [projectCode, setProjectCode] = useState()
  const [categoryType, setCategoryType] = useState()
  const [period, setPeriod] = useState()

  const [location, setLocation] = useState([])

  const containerRef = React.createRef();
  const containerRefs = useRef({})

  const setContainerRef = (id, node) => {
    console.log('containerRefs.current[id]', containerRefs.current[id])

    if (node && isEmpty(containerRefs.current[id])) {
      containerRefs.current[id] = node;
    } else {
      //delete containerRefs.current[id];
    }
  }

  useEffect(() => {
    if (formSchema) {
      setAssessmentProjectId(formSchema.assessmentProjectId)
      setAssessmentId(formSchema.assessmentId)
      setProjectCode(formSchema.projectCode)
      setCategoryType(formSchema.categoryType)
      setPeriod(formSchema.period)
      setIsDraftAssessment(formSchema.isDraft)

      if (isPanel && !formSchema.assessmentProjectId && !disabled) {
        setIsEdit(true)
      }
    }

    if (isLocation(formSchema.assessmentCategoryForm)) {
      handleLocation()
    }
  }, [formSchema])

  const handleLocation = async () => {
    let locationJson = await loadLocation()

    setLocation(locationJson || [])
  }

  const isLocation = (datas) => {
    if (Array.isArray(datas)) {
      for (let index = 0; index < datas.length; index++) {
        var obj = datas[index]?.questions?.find((e) => [7, 8].includes(e.questionType))
        if (obj) {
          return true
        }
      }
    }

    return false
  }

  function createEmptyBlock() {
    return {
      id: uuidv4(),
      assessmentType: 1, //หมวดหมู่แบบสอบถาม
      questions: [createEmptyQuestion()],
    }
  }

  function createEmptyQuestion() {
    return {
      id: `cat-${uuidv4()}`,
      questionType: 1, //ประเภทคำถาม
      questionName: 'ระบุคำถาม', //ชื่อคำถาม
      radioAndCheckBoxOptions: ['ตัวเลือกที่ 1'],
      ratingMaximum: 5,
    }
  }

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await saveAssessmentForm(request)

      if (response) {
        setFormSchema(response)
        setQuestionBlocks(response.assessmentCategoryForm || [])

        if (isPanel && !request.isSaveDraft) {
          setIsEdit(false)
        }

        notification.open('success', {
          title: request.isSaveDraft ? SAVE_DRAFT_SUCCESS_MSG : SAVE_SUCCESS_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        notification.open('error', {
          title: e.response.data.errors?.message || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    }
    setIsShowConfirm(false)
    doneLoading()
    setIsLoading(false)
  }

  const handleChangeInput = (blockId, qIndex, index, value) => {
    setQuestionBlocks((prev) =>
      prev.map((block) => {
        if (block.id !== blockId) return block
        block.questions[qIndex].radioAndCheckBoxOptions.splice(index, 1, value)
        var updatedQuestions = [...block.questions]
        return { ...block, questions: updatedQuestions }
      })
    )
  }

  const handleAddQuestion = (blockId) => {
    setQuestionBlocks((prev) =>
      prev.map((block) => {
        if (block.id !== blockId) return block
        const updatedQuestions = [...block.questions, createEmptyQuestion()]
        return { ...block, questions: updatedQuestions }
      })
    )
  }

  const handleCopyQuestion = (blockId, qIndex) => {
    setQuestionBlocks((prev) =>
      prev.map((block) => {
        if (block.id !== blockId) return block
        var updatedQuestions = [...block.questions]
        const copyQuiz = block.questions[qIndex]
        updatedQuestions.splice(qIndex + 1, 0, copyQuiz)
        return { ...block, questions: updatedQuestions }
      })
    )
  }

  const handleRemoveQuestion = (blockId, qIndex) => {
    setQuestionBlocks((prev) =>
      prev.map((block) => {
        if (block.id !== blockId) return block
        var updatedQuestions = [...block.questions]
        updatedQuestions.splice(qIndex, 1)
        return { ...block, questions: updatedQuestions }
      })
    )
  }

  const renderChoices = (quiz, qIndex, blockId) => {
    const questionType = quiz?.questionType

    return (
      <div key={quiz.id} style={{ marginBottom: 8 }}>
        {questionType === 1 &&
          (!isEdit ? (
            <span>
              {quiz?.optionsIdAnswer.length > 0 ? (
                quiz.radioAndCheckBoxOptions.map((item) => {
                  return (
                    <p>
                      {quiz.optionsIdAnswer?.includes(item.value) ? (
                        <Icon icon="check-circle" />
                      ) : (
                        <Icon icon="circle-o" />
                      )}{' '}
                      {item.label}
                    </p>
                  )
                })
              ) : (
                //getValueFromOptions(quiz.radioAndCheckBoxOptions, quiz.optionsIdAnswer[0])
                <i style={{ opacity: '0.5' }}>--ไม่ระบุ--</i>
              )}
            </span>
          ) : (
            <Row>
              {showRequiredMessage && quiz?.required && quiz?.optionsIdAnswer.length == 0 && (
                <Message showIcon type="error" description={'กรุณากรอกคำตอบ'} />
              )}
              <RadioGroup
                value={quiz?.optionsIdAnswer.length > 0 ? quiz.optionsIdAnswer[0] : null}
                onChange={(value) => {
                  updateQuestionAndChoice(blockId, quiz.id, 'optionsIdAnswer', [value])
                  // props.onChange(value)
                  //onSelect(value)
                }}
              >
                {quiz.radioAndCheckBoxOptions?.map((item, index) => (
                  <Row style={{ marginBottom: 5 }}>
                    <Col lg={24} md={24} sm={24} xs={24}>
                      <Radio key={item.value} value={item.value}>
                        <span>{item.label}</span>
                      </Radio>
                    </Col>
                  </Row>
                ))}
              </RadioGroup>
            </Row>
          ))}

        {questionType === 2 &&
          (!isEdit ? (
            <span>
              {quiz?.optionsIdAnswer.length > 0 ? (
                quiz.radioAndCheckBoxOptions.map((item) => {
                  return (
                    <p>
                      {quiz.optionsIdAnswer?.includes(item.value) ? (
                        <Icon icon="check-square-o" />
                      ) : (
                        <Icon icon="square-o" />
                      )}{' '}
                      {item.label}
                    </p>
                  )
                })
              ) : (
                //getValueFromOptions(quiz.radioAndCheckBoxOptions, quiz.optionsIdAnswer[0])
                <i style={{ opacity: '0.5' }}>--ไม่ระบุ--</i>
              )}
            </span>
          ) : (
            <Row>
              {showRequiredMessage && quiz?.required && quiz?.optionsIdAnswer.length == 0 && (
                <Message showIcon type="error" description={'กรุณากรอกคำตอบ'} />
              )}
              <CheckboxGroup
                value={quiz?.optionsIdAnswer || []}
                onChange={(value) => {
                  updateQuestionAndChoice(blockId, quiz.id, 'optionsIdAnswer', [...value])
                  // props.onChange(value)
                  //onSelect(value)
                }}
              >
                {quiz.radioAndCheckBoxOptions?.map((item, index) => (
                  <Row style={{ marginBottom: 5 }}>
                    <Col lg={24} md={24} sm={24} xs={24}>
                      <Checkbox key={item.value} value={item.value}>
                        <span>{item.label}</span>
                      </Checkbox>
                    </Col>
                  </Row>
                ))}
              </CheckboxGroup>
            </Row>
          ))}

        {questionType === 3 &&
          (!isEdit ? (
            <span>
              {quiz?.textAnswer ? quiz.textAnswer : <i style={{ opacity: '0.5' }}>--ไม่ระบุ--</i>}
            </span>
          ) : (
            <Row>
              {showRequiredMessage && quiz?.required && isEmpty(quiz?.textAnswer) && (
                <Message showIcon type="error" description={'กรุณากรอกคำตอบ'} />
              )}
              <Input
                componentClass="textarea"
                placeholder="คำตอบยาว"
                value={quiz.textAnswer}
                onChange={(value) => {
                  updateQuestionAndChoice(blockId, quiz.id, 'textAnswer', value)
                }}
              />
              <ShowLimitLength textLength={quiz.textAnswer?.length || 0} maxLength={4000} />
            </Row>
          ))}

        {questionType === 4 &&
          (!isEdit ? (
            <span>
              {quiz?.textAnswer ? quiz.textAnswer : <i style={{ opacity: '0.5' }}>--ไม่ระบุ--</i>}
            </span>
          ) : (
            <Row>
              {showRequiredMessage && quiz?.required && isEmpty(quiz?.textAnswer) && (
                <Message showIcon type="error" description={'กรุณากรอกคำตอบ'} />
              )}
              <Col lg={24} md={24} sm={24} xs={24}>
                <Input
                  placeholder="คำตอบสั้น"
                  value={quiz.textAnswer}
                  onChange={(value) => {
                    updateQuestionAndChoice(blockId, quiz.id, 'textAnswer', value)
                  }}
                />
                <ShowLimitLength textLength={quiz.textAnswer?.length || 0} maxLength={255} />
              </Col>
            </Row>
          ))}

        {questionType === 5 &&
          (!isEdit ? (
            <span>
              {quiz?.numberAnswer != null ? (
                budgetFormat(quiz.numberAnswer)
              ) : (
                <i style={{ opacity: '0.5' }}>--ไม่ระบุ--</i>
              )}
            </span>
          ) : (
            <Row>
              {showRequiredMessage && quiz?.required && quiz?.numberAnswer == null && (
                <Message showIcon type="error" description={'กรุณากรอกคำตอบ'} />
              )}
              <Col lg={24} md={24} sm={24} xs={24}>
                <NumberFormat
                  className={classNames('rs-input')}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale
                  placeholder="ตัวเลข"
                  value={quiz.numberAnswer}
                  onValueChange={(value) => {
                    updateQuestionAndChoice(blockId, quiz.id, 'numberAnswer', value.floatValue)
                  }}
                />
              </Col>
            </Row>
          ))}

        {questionType === 6 && (
          <Row>
            {showRequiredMessage && quiz?.required && quiz?.ratingAnswer == null && (
              <Message showIcon type="error" description={'กรุณากรอกคำตอบ'} />
            )}

            <br />
            {quiz.ratingMaximum > 0 && (
              <Row style={{ textAlign: 'center' }}>
                <Rate
                  defaultValue={quiz.ratingMaximum / 2}
                  max={quiz.ratingMaximum}
                  classPrefix="rs-rate rs-rate-size-xl"
                  value={quiz.ratingAnswer || 0}
                  onChange={(value) =>
                    updateQuestionAndChoice(blockId, quiz.id, 'ratingAnswer', value)
                  }
                  readOnly={!isEdit ? true : false}
                />
              </Row>
            )}
          </Row>
        )}

        {questionType === 7 &&
          (!isEdit ? (
            <span>
              {!isEmpty(quiz?.areaAnswer) ? (
                <ul>
                  {getLabelsWithParents(location, quiz.areaAnswer)?.map((e) => {
                    return <li key={e}>{e}</li>
                  })}
                </ul>
              ) : (
                <i style={{ opacity: '0.5' }}>--ไม่ระบุ--</i>
              )}
            </span>
          ) : (
            <Row>
              {showRequiredMessage && quiz?.required && isEmpty(quiz?.areaAnswer) && (
                <Message showIcon type="error" description={'กรุณากรอกคำตอบ'} />
              )}

              <Col lg={24} md={24} sm={24} xs={24}>
                <Cascader
                  block
                  menuWidth={200}
                  data={location}
                  placeholder={'พื้นที่แบบตัวเลือกเดี่ยว'}
                  value={quiz?.areaAnswer.length > 0 ? quiz.areaAnswer[0] : null}
                  onChange={(value) => {
                    updateQuestionAndChoice(blockId, quiz.id, 'areaAnswer', value ? [value] : [])
                  }}
                />
              </Col>
            </Row>
          ))}

        {questionType === 8 &&
          (!isEdit ? (
            <span>
              {!isEmpty(quiz?.areaAnswer) ? (
                <Row>
                  <RenderLocationTree data={buildFilteredTree(location, quiz.areaAnswer)} />
                </Row>
              ) : (
                <i style={{ opacity: '0.5' }}>--ไม่ระบุ--</i>
              )}
            </span>
          ) : (
            <Row>
              {showRequiredMessage && quiz?.required && isEmpty(quiz?.areaAnswer) && (
                <Message showIcon type="error" description={'กรุณากรอกคำตอบ'} />
              )}

              <Col lg={24} md={24} sm={24} xs={24}>
                <MultiCascader
                  block
                  menuWidth={200}
                  data={location}
                  placeholder={'ตัวอย่างพื้นที่แบบหลายตัวเลือก'}
                  renderValue={(value, selectedItems) => {
                    return <span>{selectedItems?.map((item) => item.label).join(' , ')}</span>
                  }}
                  value={quiz?.areaAnswer.length > 0 ? quiz.areaAnswer : []}
                  onChange={(value) => {
                    updateQuestionAndChoice(blockId, quiz.id, 'areaAnswer', value)
                  }}
                />
              </Col>
            </Row>
          ))}

        {questionType === 9 &&
          (!isEdit ? (
            <span>
              {quiz?.optionsIdAnswer.length > 0 ? (
                getValueFromOptions(quiz.radioAndCheckBoxOptions, quiz.optionsIdAnswer[0])
              ) : (
                <i style={{ opacity: '0.5' }}>--ไม่ระบุ--</i>
              )}
            </span>
          ) : (
            <Row>
              {showRequiredMessage && quiz?.required && isEmpty(quiz?.optionsIdAnswer) && (
                <Message showIcon type="error" description={'กรุณาเลือกคำตอบ'} />
              )}
              <SelectPicker
                data={quiz.radioAndCheckBoxOptions}
                value={quiz?.optionsIdAnswer.length > 0 ? quiz.optionsIdAnswer[0] : null}
                block
                searchable
                placeholder={'เลือกคำตอบ'}
                onChange={(value) => {
                  updateQuestionAndChoice(blockId, quiz.id, 'optionsIdAnswer', value ? [value] : [])
                }}
              />
            </Row>
          ))}
      </div>
    )
  }

  const handleAddBlock = (index) => {
    const newBlock = createEmptyBlock()
    if (typeof index === 'number') {
      //แทรกที่ index
      setQuestionBlocks((prev) => [...prev.slice(0, index + 1), newBlock, ...prev.slice(index + 1)])
    } else {
      setQuestionBlocks((prev) => [...prev, newBlock])
    }
  }

  const handleRemoveBlock = (id) => {
    setQuestionBlocks((prev) => prev.filter((b) => b.id !== id))
  }

  const updateBlock = (blockId, field, value) => {
    setQuestionBlocks((prev) =>
      prev.map((b) => {
        if (b.id !== blockId) {
          return b
        }
        return { ...b, [field]: value }
      })
    )
  }

  const updateQuestionAndChoice = (blockId, quizId, field, value) => {
    const updateTree = (nodes) => {
      return nodes.map((node) => {
        // ถ้า blockId ตรง → อัปเดต questions ใน block นี้
        let updatedQuestions = node.questions
        if (node.id === blockId) {
          updatedQuestions =
            node.questions?.map((qz) => {
              if (qz.id !== quizId) return qz
              return {
                ...qz,
                [field]: value,
              }
            }) || []
        }

        // recursive ลงไปใน children
        const updatedChildren = node.children?.length ? updateTree(node.children) : []

        return {
          ...node,
          questions: updatedQuestions,
          children: updatedChildren,
        }
      })
    }

    setQuestionBlocks((prev) => updateTree(prev))
  }

  const validateAnswer = (question) => {
    var isAnswer = false
    if (question) {
      switch (question.questionType) {
        case 1:
          isAnswer = isEmpty(question.optionsIdAnswer) ? false : true
          break
        case 2:
          isAnswer = isEmpty(question.optionsIdAnswer) ? false : true
          break
        case 3:
          isAnswer = isEmpty(question.textAnswer) ? false : true
          break
        case 4:
          isAnswer = isEmpty(question.textAnswer) ? false : true
          break
        case 5:
          isAnswer = question.numberAnswer == null ? false : true
          break
        case 6:
          isAnswer = question.ratingAnswer == null ? false : true
          break
        case 7:
          isAnswer = isEmpty(question.areaAnswer) ? false : true
          break
        case 8:
          isAnswer = isEmpty(question.areaAnswer) ? false : true
          break
        case 9:
          isAnswer = isEmpty(question.optionsIdAnswer) ? false : true
          break
        default:
          return false
      }
    }

    return isAnswer
  }

  const handleClickSubmitButton = () => {
    if (!questionBlocks) return

    for (const block of questionBlocks) {
      for (const q of block.questions || []) {
        if (q.required) {
          const isAnswer = validateAnswer(q)

          if (!isAnswer) {
            notification.open('error', {
              title: 'กรุณากรอกแบบประเมินให้ครบถ้วน',
              duration: 5000,
            })

            setShowRequiredMessage(true)
            return
          }
        }
      }
    }

    setIsShowConfirm(true)
  }

  const handleSubmit = (isDraft) => {
    console.log('questionBlocks:', questionBlocks)
    setShowRequiredMessage(false)

    // สร้าง object ตาม format ที่ต้องการ
    const request = {
      assessmentProjectId: assessmentProjectId,
      assessmentId: assessmentId,
      projectCode: projectCode,
      projectVersionId: null,
      periodNo: period,
      categoryType: categoryType,
      isSaveDraft: !!isDraft,
      assessmentCategoryForm: questionBlocks,
      progressId: progressId,
      assessmentFor: assessmentFor,
    }
    console.log('📦 ข้อมูลฟอร์ม:', request)

    handleSave(request)
  }

  const findLabelByValue = (options, value) => {
    for (const item of options) {
      if (item.value == value) {
        return item.label // เจอ value ตรงกัน
      }
      if (item.children && item.children.length > 0) {
        const found = findLabelByValue(item.children, value)
        if (found) {
          return found // ถ้าเจอใน children ก็ return
        }
      }
    }
    return null // ถ้าไม่เจอ
  }

  const countAnswer = (question = []) => {
    var countAns = 0
    if (question?.length > 0) {
      question.forEach((item) => {
        switch (item.questionType) {
          case 1:
            !isEmpty(item.optionsIdAnswer) ? (countAns += 1) : null
            break
          case 2:
            !isEmpty(item.optionsIdAnswer) ? (countAns += 1) : null
            break
          case 3:
            !isEmpty(item.textAnswer) ? (countAns += 1) : null
            break
          case 4:
            !isEmpty(item.textAnswer) ? (countAns += 1) : null
            break
          case 5:
            item.numberAnswer != null ? (countAns += 1) : null
            break
          case 6:
            item.ratingAnswer != null ? (countAns += 1) : null
            break
          case 7:
            !isEmpty(item.areaAnswer) ? (countAns += 1) : null
            break
          case 8:
            !isEmpty(item.areaAnswer) ? (countAns += 1) : null
            break
          case 9:
            !isEmpty(item.optionsIdAnswer) ? (countAns += 1) : null
            break
          default:
            break
        }
      })

      return `(${countAns}/${question?.length})`
    }
    return ''
  }

  const renderBlock = (block, index) => {
    var _expanded = block.expanded != undefined ? block.expanded : true

    console.log('_expanded', block.assessmentType, _expanded)

    var _node
    return (
      <div ref={(node) => setContainerRef(block.id, node)}>
        <Panel
          bordered
          key={block.id}
          style={{ marginBottom: 16, backgroundColor: '#2da888' }}
          collapsible
          defaultExpanded
          expanded={_expanded}
          onSelect={(i)=>{
            //let _expanded = block.expanded != undefined ? block.expanded : true
            updateBlock(block.id, 'expanded', !_expanded)

            // if(!_expanded){
            //   //delete containerRefs.current[block.id]
            //   setContainerRef(block.id, <div></div>)
            // }
            // if(_expanded){
            //   setContainerRef(block.id, _node)
            // }else{
            //   setContainerRef(block.id, null)
            // }
            
          }}
          header={
            <div>
              <Affix
                top={0}
                container={() => {
                  console.log('containerRefs.current', containerRefs.current)
                  // let _expanded = block.expanded != undefined ? block.expanded : true
                  // console.log('containerRefs.current[block.id]', containerRefs.current[block.id])
                  // console.log('_expanded', _expanded)
                  return containerRefs.current[block.id]
                }}
                onChange={(i)=>console.log(i)}
              >
              <b style={{ color: '#fff', backgroundColor: '#2da888', borderRadius: 5 }}>{`${block.assessmentType} ${countAnswer(
                block.questions
              )}`}</b>
             </Affix>
            </div>
           
          }
        >
          <div>
            {block?.questions?.map((quiz, qIndex) => (
              <Panel style={{ marginBottom: 10 }}>
                <Row style={{ marginBottom: 10, marginTop: 10 }}>
                  <Col lg={24} md={24} sm={24} xs={24} style={{ marginBottom: 10 }}>
                    <ControlLabel className={classNames(quiz.required && 'required')}>
                      {quiz.questionName}
                    </ControlLabel>
                  </Col>
                </Row>

                {renderChoices(quiz, qIndex, block.id)}
              </Panel>
            ))}
          </div>

          {block.children?.map((ch, index) => {
            return renderBlock(ch, index)
          })}
        </Panel>
      </div>
    )
  }

  return (
    <>
      <Panel
        shaded
        collapsible
        defaultExpanded
        header={
          isPanel ? (
            <span>{formSchema?.assessmentName || ''}</span>
          ) : (
            <b>{formSchema?.assessmentName || ''}</b>
          )
        }
        bordered
      >
        {formSchema?.assessmentDescription && <Message type="info" showIcon description={formSchema?.assessmentDescription} />}

        <br/>
        {questionBlocks?.length > 0 ? (
          questionBlocks?.map((block, index) => renderBlock(block, index))
        ) : (
          <Message type="error" showIcon description={`ไม่พบคำถามแบบประเมิน`} />
        )}

        {isPanel && !isPreview && !disabled && (
          <Row>
            {isEdit ? (
              <>
                <SaveButton
                  onClick={() => handleClickSubmitButton()}
                  style={{ marginRight: 10, marginBottom: 10, backgroundColor: '#fff' }}
                >
                  บันทึกแบบประเมิน
                </SaveButton>

                <SaveButton
                  onClick={() => handleSubmit(true)}
                  style={{ marginRight: 10, marginBottom: 10, backgroundColor: '#fff' }}
                >
                  บันทึกร่าง
                </SaveButton>

                <CancelButton
                  onClick={() => {
                    setIsEdit(false)
                    setQuestionBlocks(formSchema.assessmentCategoryForm || [])
                  }}
                >
                  ยกเลิก
                </CancelButton>
              </>
            ) : (
              <>
                <EditButton
                  onClick={() => {
                    setIsEdit(true)
                    setShowRequiredMessage(false)
                  }}
                >
                  แก้ไข
                </EditButton>
              </>
            )}
          </Row>
        )}

        {!isPanel && !isPreview && !disabled && (
          <div
            style={{
              position: 'fixed',
              zIndex: 997,
              right: '6em',
              bottom: '0.5em',
              textAlign: 'right',
            }}
          >
            <Row>
              <Col lg={16} md={16} sm={24} xs={24}></Col>
              <Col lg={8} md={8} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <SaveButton
                  className={'rs-panel-shaded'}
                  onClick={() => handleSubmit(true)}
                  style={{ marginRight: 10, marginBottom: 10, backgroundColor: '#fff' }}
                >
                  บันทึกร่าง
                </SaveButton>
              </Col>
            </Row>
          </div>
        )}
      </Panel>
      <br />

      <ConfirmWidget
        title={`ส่งแบบประเมิน`}
        show={isShowConfirm}
        detail={'ยืนยันการส่งแบบประเมิน'}
        onCancle={() => {
          setIsShowConfirm(false)
        }}
        onConfirm={() => handleSubmit(false)}
      />
    </>
  )
}

const ratingOptions = [
  {
    value: 1,
    label: '1',
  },
  {
    value: 2,
    label: '2',
  },
  {
    value: 3,
    label: '3',
  },
  {
    value: 4,
    label: '4',
  },
  {
    value: 5,
    label: '5',
  },
  {
    value: 6,
    label: '6',
  },
  {
    value: 7,
    label: '7',
  },
  {
    value: 8,
    label: '8',
  },
  {
    value: 9,
    label: '9',
  },
  {
    value: 10,
    label: '10',
  },
]

const location = [
  {
    id: '1',
    label: 'จักหวัด A',
    value: '1',
    children: [
      {
        id: '11',
        label: 'อำเภอ A',
        value: '1-1',
        children: [
          {
            id: '111',
            label: 'ตำบล A',
            value: '1-1-1',
            children: [
              {
                id: '1111',
                label: 'รหัสไปรษณีย์ A',
                value: '1-1-1-1',
              },
            ],
          },
          {
            id: '112',
            label: 'ตำบล AA',
            value: '1-1-2',
            children: [
              {
                id: '1121',
                label: 'รหัสไปรษณีย์ AA',
                value: '1-1-2-1',
              },
            ],
          },
        ],
      },
      {
        id: '12',
        label: 'อำเภอ AB',
        value: '1-2',
        children: [
          {
            id: '121',
            label: 'ตำบล AB',
            value: '1-2-1',
            children: [
              {
                id: '1211',
                label: 'รหัสไปรษณีย์ AB',
                value: '1-1-1-1',
              },
            ],
          },
          {
            id: '122',
            label: 'ตำบล AC',
            value: '1-2-2',
            children: [
              {
                id: '1221',
                label: 'รหัสไปรษณีย์ AC',
                value: '1-2-2-1',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: '2',
    label: 'จักหวัด B',
    value: '2',
    children: [
      {
        id: '21',
        label: 'อำเภอ B',
        value: '2-1',
        children: [
          {
            id: '211',
            label: 'ตำบล B',
            value: '2-1-1',
            children: [
              {
                id: '2111',
                label: 'รหัสไปรษณีย์ B',
                value: '2-1-1-1',
              },
            ],
          },
          {
            id: '212',
            label: 'ตำบล BB',
            value: '2-1-2',
            children: [
              {
                id: '2121',
                label: 'รหัสไปรษณีย์ BB',
                value: '2-1-2-1',
              },
            ],
          },
          {
            id: '213',
            label: 'ตำบล BC',
            value: '2-1-3',
            children: [
              {
                id: '2131',
                label: 'รหัสไปรษณีย์ BC',
                value: '2-1-3-1',
              },
            ],
          },
        ],
      },
    ],
  },
]
